// src/components/ProgressTracker.js
import React from 'react';
import './ProgressTracker.css';

const progressSteps = [
  { key: 'not_started', label: 'Start' },
  { key: 'consent', label: 'Consent' },
  { key: 'pre_experiment', label: 'Pre-Experiment' },
  { key: 'documentation_intro', label: 'Documentation Intro' }, // renamed display label
  { key: 'platform_tutorial', label: 'Platform Tutorial' },
  { key: 'documentation_review', label: 'Documentation Review' },
  { key: 'website1', label: 'Pentesting' },
  // Website 2 is temporarily disabled — uncomment to re-enable
  // { key: 'website2', label: 'Website 2 (Optional)' },
  { key: 'post_experiment', label: 'Post-Experiment' },
  { key: 'end', label: 'Debrief' },
];

function ProgressTracker({ currentStep }) {
  const currentIndex = progressSteps.findIndex(step => step.key === currentStep);

  return (
    <div className="tracker-container mb-4">
      {progressSteps.map((step, index) => (
        <div key={step.key} className="tracker-step">
          <div className={`tracker-circle ${index <= currentIndex ? 'completed' : ''}`}>
            {index + 1}
          </div>
          <div className={`tracker-label ${index <= currentIndex ? 'completed' : ''}`}>
            {step.label}
          </div>
          {index < progressSteps.length - 1 && (
            <div className={`tracker-line ${index < currentIndex ? 'completed' : ''}`} />
          )}
        </div>
      ))}
    </div>
  );
}

export default ProgressTracker;
